var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#181725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 18.0069 18.0176 23 12 23C5.99314 23 1 18.0069 1 12C1 5.98235 5.98235 1 11.9892 1C18.0069 1 23 5.98235 23 12ZM17.3957 6.60429C17.7295 6.93802 17.7295 7.47912 17.3957 7.81286L13.2086 12L17.3957 16.1871C17.7295 16.5209 17.7295 17.062 17.3957 17.3957C17.062 17.7295 16.5209 17.7295 16.1871 17.3957L12 13.2086L7.81286 17.3957C7.47912 17.7295 6.93802 17.7295 6.60429 17.3957C6.27055 17.062 6.27055 16.5209 6.60429 16.1871L10.7914 12L6.60429 7.81286C6.27055 7.47912 6.27055 6.93802 6.60429 6.60429C6.93802 6.27055 7.47912 6.27055 7.81286 6.60429L12 10.7914L16.1871 6.60429C16.5209 6.27055 17.062 6.27055 17.3957 6.60429Z",
    fill: "#565470"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b3a0c89fd0b9eb5094253d20871d89b2.svg";
export { ForwardRef as ReactComponent };